/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
//  based off of react-hook-mui components. That repository does not have a component for multivalue text fields
import { TextField, Autocomplete, TextFieldProps, AutocompleteRenderInputParams, Box, InputAdornment, Chip } from "@mui/material";
import { useState } from "react";
import { Control, Controller, ControllerProps, FieldError } from "react-hook-form";

export type TextFieldElementProps = Omit<TextFieldProps,
  'name'> & {
  validation?: ControllerProps['rules']
  name: string
  parseError?: (error: FieldError) => string
  control?: Control<any>
  label?: string
}

export default function MultivalueText({
  validation = {},
  parseError,
  type,
  required,
  name,
  control,
  helperText,
  fullWidth,
  sx,
  ...rest
  }: TextFieldElementProps): JSX.Element {



    if (required) {
      validation.required = 'This field is required'
    }
    if (type === 'email') {
      validation.pattern = {
        // eslint-disable-next-line no-useless-escape
        value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Please enter a valid email address'
      }
    }

    

    return (
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        rules={validation}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Autocomplete
            {...field}
            freeSolo
            autoSelect
            multiple
            fullWidth={fullWidth}
            onChange={(_event, value,reason) =>{ 
            
              field.onChange(value);
            }}
            options={[]}
            renderInput={(params) => (<>
              <TextField
                {...rest}
                required={required}
                error={!!error}
                helperText={error?.message || helperText}
                name={name}
                type="search"
                inputRef={ref}
           
                {...params}
                fullWidth={fullWidth}
                sx={sx}
              />
              </>
            )}
            renderTags={(tagValue, getTagProps) => {
              return tagValue.map((option, index) => 
                 <Chip {...getTagProps({ index })} label={option}></Chip>
              );
              }}
              
          />
        )}
      />
     
  )
}
